import { PosIconProps, SvgWrapper } from './SvgWrapper';

export const SortIcon = (props: PosIconProps) => {
  return (
    <SvgWrapper {...props} viewBox="0 0 20 18">
      <path
        d="M4.66676 1V17M4.66676 17L7.71438 13.9524M4.66676 17L1.61914 13.9524"
        stroke={props.fill ?? '#677383'}
        strokeWidth="1.52381"
        strokeLinecap="round"
      />
      <path
        d="M15.3335 16.619L15.3335 1.38095M15.3335 1.38095L12.2859 4.42857M15.3335 1.38095L18.3811 4.42857"
        stroke={props.fill ?? '#677383'}
        strokeWidth="1.52381"
        strokeLinecap="round"
      />
    </SvgWrapper>
  );
};
